import { loadStripe } from "@stripe/stripe-js"
import { axiosWrapper } from "../../axios_old"

const FRONTEND_SERVER = {
	"localhost:8080": "localhost:8080",
	"my.salusion-preprod.com": "@",
	"my.salusion.com": "@"
}

const _getStripeConfig = async ({ isPartner, email, user }) => {
	const { data } = await axiosWrapper(
		"POST",
		"stripe/checkout",
		{
			server: FRONTEND_SERVER[window.location.host],
			onSuccess: `${window.location.pathname}?r=success`,
			onCancel: window.location.pathname,
			isAgent: Boolean(isPartner),
			email
		},
		null,
		user.token
	)

	return data
}

const APIStripe = async (args) => {
	const { user, data, action, setNotification, history } = args
	try {
		let newData = {}

		if (action === "CREATE") {
			const stripeConfig = await _getStripeConfig({
				user,
				isPartner: data.isPartner,
				email: data.email
			})

			const stripePromise = loadStripe(stripeConfig?.publishableKey)
			localStorage.setItem("stripe", stripeConfig?.sessionId)
			const stripe = await stripePromise
			const { error } = await stripe.redirectToCheckout({
				sessionId: stripeConfig?.sessionId
			})

			console.error(error)

			//   newData = { ...data, ...signupData };
		}
		return newData
	} catch (err) {
		console.error(err)

		await setNotification("notification", true, {
			msg: err.response?.data.message,

			severity: "error"
		})
	}
}

export default APIStripe
